"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheatCodesFirestore = void 0;
class CheatCodesFirestore {
    constructor(rawFirestore) {
        this.rawFirestore = rawFirestore;
        // construct
    }
    clear() {
        return this.rawFirestore.clearCheatCodes();
    }
    createMany(cheatCodes) {
        return this.rawFirestore.setCheatCodes(cheatCodes);
    }
}
exports.CheatCodesFirestore = CheatCodesFirestore;
